import { AsciiText } from '../framework/AsciiText';
export class JblSynthesis {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.power = false;
        this.routes = [0x04, 0x04]; // set to SAT
        this.versions = {
            0xf0: [0x01, 0x04],
            0xf1: [0x01, 0x00],
            0xf2: [0x00, 0x00],
            0xf3: [0x01, 0x01],
            0xf4: [0x01, 0x00],
            0xf5: [0x01, 0x00], // IAP version
        };
        this.volume = 60;
        this.volumeMute = false;
        // Translates the 'set' values to quipmentTypes source codes.
        this.sourceLookup = {
            // Zone 1 set values to source value
            1: {
                0x76: 1,
                0x62: 2,
                0x5e: 3,
                0x1b: 4,
                0x60: 5,
                0x7d: 6,
                0x63: 8,
                0x3a: 9,
                0x1c: 11,
                0x48: 12,
                0x5c: 14,
                0x64: 16,
                0x61: 17,
                0x7a: 18, // BT
            },
            2: {
                //
                // Zone 2 values
                //
                0x06: 1,
                0x07: 2,
                0x09: 3,
                0x14: 4,
                0x0f: 5,
                0x17: 6,
                0x0d: 8,
                // No Display source
                0x1e: 11,
                0x10: 12,
                0x13: 14,
                0x08: 16,
                0x0b: 17,
                0x16: 18, // BT
            },
        };
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /!\x01\x04\x01([\S\s])\x0d/,
                callback: (match) => {
                    var _a;
                    const fwType = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x04,
                        0x00,
                        0x03,
                        fwType,
                        ...((_a = this.versions[fwType]) !== null && _a !== void 0 ? _a : [0, 0]),
                    ]));
                },
            },
            {
                name: 'powerQuery',
                regExp: /!\x01\x00\x01\xf0\x0d/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x01, 0x00, 0x00, 0x01, this.power ? 0x01 : 0x00]));
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /!\x01\x08\x02\x10([\x1a\x78])\x0d/,
                callback: (match) => {
                    this.volumeMute = match[1].charCodeAt(0) === 0x1a;
                    this.socket.send(this.makeCommand([0x01, 0x08, 0x00, 0x02, 0x10, match[1].charCodeAt(0)]));
                },
            },
            {
                name: 'powerSet',
                regExp: /!\x01\x08\x02\x10([\x7b\x7c])\x0d/,
                callback: (match) => {
                    this.power = match[1].charCodeAt(0) === 0x7b;
                    console.log(`emulator: setting power to ${this.power}`);
                    this.socket.send(this.makeCommand([0x01, 0x08, 0x00, 0x02, 0x10, this.power ? 0x7b : 0x7c]));
                },
            },
            {
                name: 'routeGet',
                regExp: /!([\S\s])\x1d\x01\xf0\x0d/,
                callback: (match) => {
                    const zone = match[1].charCodeAt(0);
                    if (zone < 1 || zone > 2) {
                        this.log.error(`zone out of range: ${zone}`);
                        return;
                    }
                    const input = this.routes[zone - 1];
                    this.socket.send(this.makeCommand([zone, 0x1d, 0x00, 0x01, input]));
                },
            },
            {
                name: 'routeSet',
                regExp: /!([\S\s])\x08\x02([\S\s]{2})\x0d/,
                callback: (match) => {
                    var _a;
                    const zone = match[1].charCodeAt(0);
                    // const rcCodePrefix = match[2].charCodeAt(0);
                    const rcCode = match[2].charCodeAt(1);
                    if (zone < 1 || zone > 2) {
                        this.log.error(`zone out of range: ${zone}`);
                        return;
                    }
                    const videoCode = (_a = this.sourceLookup[zone][rcCode]) !== null && _a !== void 0 ? _a : 0x04; // SAT
                    this.routes[zone - 1] = videoCode;
                    // Route set doesn't seem to send back an ack when testing with a real device
                    /*
                    this.socket.send(
                        this.makeCommand([zone, 0x08, 0x00, 0x02, rcCodePrefix, videoCode])
                    ); */
                },
            },
            {
                name: 'volumeQuery',
                regExp: /!\x01\x0d\x01\xf0\x0d/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x01, 0x0d, 0x00, 0x01, this.volume]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /!\x01\x0d\x01([\S\s])\x0d/,
                callback: (match) => {
                    this.volume = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([0x01, 0x0d, 0x00, 0x01, this.volume]));
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /!\x01\x0e\x01\xf0\x0d/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x01, 0x0e, 0x00, 0x01, this.volumeMute ? 0 : 1]));
                },
            },
        ];
        this.commandExtractor = {
            terminators: [],
            unterminatedRegExp: /\x21[\x01\x02][\S\s][\S\s]{1,3}\x0d/i,
        };
        this.sendTerminator = '\x0d';
    }
    makeCommand(command) {
        const data = [0x21]; // ! command header
        data.push(...command);
        return AsciiText.decode(data);
    }
}
JblSynthesis.emulatorType = 'socketEmulator';
JblSynthesis.key = '-O46HBLHvrLrJk2X58iB';
